const pluralize = (word: string, count: number, suffix = 's'): string =>
  count === 1 ? word : `${word}${suffix}`

export default pluralize
